import styled from '@emotion/styled';
import Button from '@ep/components/Button';
import { H1 } from '@ep/components/Typography';
import Close from '@ep/images/close.svg';
import theme from '@ep/theme';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import React from 'react';
interface InfoModalProps {
  open: boolean;
  source: string;
  onClose: () => void;
}

// This has a "magic number" based on the height of the info form
const StyledModal = styled(Modal)`
  display: flex;
  align-items: start;
  justify-content: center;
  overflow-y: scroll;
`;

const Content = styled('div')`
  padding: 1.5rem;
  text-align: center;
  width: 100%;
`;

const ModalContainer = styled.div`
  position: relative;
  margin: auto auto;
  width: 50%;
  max-width: 50rem;
  background-color: ${theme.colors.white};
  outline: none;
  ${theme.mediaQueries.mobileAndTablet} {
    width: 100%;
  }
`;

const CloseButton = styled(Button)`
  width: 3rem;
  height: 3rem;
  padding: 0;
  line-height: 0.5;
  background-color: transparent;
  border-radius: 50%;
  outline: none;
  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
  ${theme.mediaQueries.mobile} {
    grid-row: 1;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 1.5rem;
  background-color: ${theme.colors.duskBlue};
  h1 {
    color: ${theme.colors.white};
    font-family: ${theme.typography.secondaryFont.light};
    font-size: 2.5rem;
  }
  ${theme.mediaQueries.mobile} {
    display: grid;
  }
`;

const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  ${theme.mediaQueries.mobile} {
    grid-row: 2;
  }
`;

const Heading = styled(H1)`
  color: ${theme.colors.white};
  ${theme.mediaQueries.mobile} {
    font-size; 0.5rem;
    text-align: center;
  }
`;

function InfoModal({ open, onClose, source }: InfoModalProps) {
  const HandleClose = () => {
    onClose();
  };

  const redirectValue = source.includes('redirect=')
    ? source.split('redirect=')[1].split('&')[0]
    : '';

  return (
    <StyledModal
      open={open}
      onClose={onClose}
      role="complementary"
      disableBackdropClick={true}
    >
      <Fade in={open}>
        <ModalContainer>
          <ModalHeader>
            <div />
            <HeaderTitle>
              <Heading>You've been redirected from... {redirectValue}</Heading>
            </HeaderTitle>
            <CloseButton
              color="gray"
              outlined
              onClick={() => HandleClose()}
              aria-label="Close"
              label={<Close />}
            />
          </ModalHeader>
          <Content>
            {redirectValue === 'shop' && (
              <>
                <h3>Here is where you'll find the latest EP products.</h3>
                <p>Please close this dialog and browse.</p>
                <p>Thank you.</p>
              </>
            )}
            {redirectValue != 'shop' && (
              <>
                <p>Thank you.</p>
              </>
            )}
          </Content>
        </ModalContainer>
      </Fade>
    </StyledModal>
  );
}

export default InfoModal;
